'use strict';

var messaging = require('shared/messaging'),

    events = require('widget/scripts/lib/commons/events/defs/events'),
    eventing = require('widget/scripts/lib/commons/events/eventing'),
    receiverHelpers = require('widget/scripts/lib/commons/receiverHelpers'),
    widgetMessagingChannels = require('widget/scripts/lib/commons/widgetMessagingChannels'),
    widgetStateManager = require('widget/scripts/lib/commons/widgetStateManager'),
    globalMessageListeners = require('widget/scripts/lib/commons/globalMessageListeners'),
    submitToReceiver = require('widget/scripts/lib/commons/submitToReceiver');

module.exports = function (visualizationType, visualizationTypeOptions) {

    var widget = this,
        visualizationTypeOptionsLocal;

    _validateArguments();

    _cloneVisualizationTypeOptions();

    _checkIfBusy();
    _checkIfNotDestroyed();

    _requestMessagingChannelIfNeeded();
    _renderIntoDOMIfNeeded();

    _requestVisualizationIfReady();

    return widget;

    function _validateArguments() {
        if (typeof (visualizationType) !== 'string' || typeof (visualizationTypeOptions) !== 'object') {
            throw new Error('iVis.Widget: getVisualization expects valid params: (string) visualizationType, (object)visualizationTypeOptions.');
        }
    }

    function _cloneVisualizationTypeOptions() {
        visualizationTypeOptionsLocal = JSON.parse(JSON.stringify(visualizationTypeOptions));
    }

    function _checkIfBusy() {
        if (widgetStateManager.isBusy(widget.id)) {
            throw new Error('iVis.Widget: your previous request is still being processed.');
        }
    }

    function _checkIfNotDestroyed() {
        if (widget.isDestroyed) {
            throw new Error('iVis.Widget: you cannot request a visualization on a destroyed widget.');
        }
    }

    function _requestMessagingChannelIfNeeded() {
        if (!_isMessagingChannelIsEstablished(widget)) {
            _requestMessagingChannel(widget, visualizationType, visualizationTypeOptionsLocal);
        }
    }

    function _renderIntoDOMIfNeeded() {
        if (!_isInDOM(widget)) {
            _setupTargetNode(widget);
            _render(widget);
        }
    }

    function _requestVisualizationIfReady() {

        if (_isReadyToSubmit(widget)) {

            widgetStateManager.setBusy(
                widget.id,
                submitToReceiver(widget, visualizationType, visualizationTypeOptionsLocal)
            );

            eventing.rise(widget, events.NO_DATA_CHANGED, false);
            eventing.rise(widget, events.BUSY_STATE_CHANGED, true);
        }
    }
};

function _isInDOM(widget) {
    return document.getElementById(widget.id) !== null;
}

function _isMessagingChannelIsEstablished(widget) {
    return widgetMessagingChannels.get(widget.id) !== null;
}

function _isReadyToSubmit(widget) {
    return _isInDOM(widget) && _isMessagingChannelIsEstablished(widget);
}

function _setupTargetNode(widget) {

    if (widget.node) {
        return;
    }

    widget.node = document.createElement('iframe');

    widget.node.setAttribute('id', widget.id);
    widget.node.setAttribute('src', receiverHelpers.getReceiverFullUrl(widget.id));
    widget.node.setAttribute('frameborder', 0);

    widget.node.setAttribute('marginheight', 0);
    widget.node.setAttribute('marginwidth', 0);
    widget.node.setAttribute('scrolling', 'no');
    widget.node.setAttribute('class', 'iVisWidget');
}

function _render(widget) {
    widget.parentNode.appendChild(widget.node);
}

function _hookUpWidgetToMessages(widget, msg, channel) {
    channel.onmessage = _processMessageFromReceiver.bind(null, widget);
}

function _processMessageFromReceiver(widget, event) {

    if (messaging.isValidMessage(event.data)) {
        if (_canSetFree(event.data)) {

            widgetStateManager.setFree(
                event.data.widgetId,
                event.data.messageId
            );

            eventing.rise(widget, events.BUSY_STATE_CHANGED, false);

            if (event.data.messageTitle === messaging.titles.NODATA) {
                eventing.rise(widget, events.NO_DATA_CHANGED, true);
            }

            if (event.data.messageTitle === messaging.titles.ERROR) {
                eventing.rise(widget, events.ERROR);
            }
        }
    }

    function _canSetFree(message) {
        return (
            (
                message.messageTitle === messaging.titles.OK ||
                message.messageTitle === messaging.titles.ERROR ||
                message.messageTitle === messaging.titles.NODATA
            ) &&
            widgetStateManager.isBusyWithMessage(message.widgetId, message.messageId)
        );
    }
}

function _requestMessagingChannel(widget, visualizationType, visualizationTypeOptions) {
    var channel = widgetMessagingChannels.get(widget.id);

    if (channel) {
        return;
    }

    globalMessageListeners.registerListener(
        widget.id,
        messaging.titles.READY,
        widgetMessagingChannels.storeFromGlobalMessageListenerParams.bind(null, widget.id)
    );

    globalMessageListeners.registerListener(
        widget.id,
        messaging.titles.READY,
        _hookUpWidgetToMessages.bind(null, widget)
    );

    globalMessageListeners.registerListener(
        widget.id,
        messaging.titles.READY,
        widget.getVisualization.bind(widget, visualizationType, visualizationTypeOptions),
        true
    );
}



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/api/getVisualization.js
// module id = 17
// module chunks = 0 1